import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Shape from 'marketing-website/components/commons/Shape';

import assets from 'marketing-website/configs/pages/pop/share.js';

export default function Share() {
  return (
    <PageWrap size="l">
      <Grid columns={12} alignItems="center">
        <GridItem columnSpan={12} columnSpanM={6}>
          <MediaMultipleImages
            fallbackImageAlt={assets.shareiOS.alt}
            fallbackImageMaxWidth={assets.shareiOS.maxWidth}
            fallbackImageSrc={assets.shareiOS.src}
          >
            <Shape
              color="brightOrange"
              height={250}
              left="12%"
              top="25%"
              type="rectangle"
              width={300}
            />
            <ParallaxWrapper speed={0.8}>
              <Image
                {...assets.hand}
                borderRadius="m"
                position="absolute"
                left="6%"
              />
            </ParallaxWrapper>
            <ParallaxWrapper speed={1.6}>
              <Image
                {...assets.planes}
                borderRadius="m"
                right="10%"
                position="absolute"
                bottom="11%"
              />
              <Image
                {...assets.stars}
                borderRadius="m"
                left="4%"
                position="absolute"
                top="16%"
              />
            </ParallaxWrapper>
          </MediaMultipleImages>
        </GridItem>
        <GridItem columnSpan={12} columnSpanM={6}>
          <Spacing size="l" sizeM="0" type="margin" position="bottom">
            <HeadingBlock
              size="s"
              spacing="m"
              justifyM="center"
              title="Instantly share your prototypes."
              copy="Send your prototypes to any mobile or web browser. You can even share on your social profile."
            />
          </Spacing>
        </GridItem>
      </Grid>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pop/Share.js